import { compact, get } from "lodash"
import { percentageFormatter } from "helpers/formatters/numbers"

export const TOTAL_RETURN = "totalReturn"
export const ALPHA_RETURN = "alphaReturn"
export const FACTORS_RETURN = "factorsReturn"
export const TRADING_RETURN = "tradingReturn"

export const METRICS = {
  [TOTAL_RETURN]: {
    label: "Total Return",
    path: "totalReturn.cumulativePercent",
    formatter: percentageFormatter,
  },
  [ALPHA_RETURN]: {
    label: "Alpha",
    path: "attribution.summary.specific.cumulativePercent",
    formatter: percentageFormatter,
  },
  [FACTORS_RETURN]: {
    label: "Factors",
    path: "attribution.summary.factors.cumulativePercent",
    formatter: percentageFormatter,
  },
  [TRADING_RETURN]: {
    label: "Trading",
    path: "attribution.summary.trading.cumulativePercent",
    formatter: percentageFormatter,
  },
}

const QUERY = `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
  model(id: $modelId) {
    simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
      performance {
        date
        totalReturn {
          cumulativePercent
        }
        attribution {
          summary {
            factors {
              cumulativePercent
            }
            specific {
              cumulativePercent
            }
            trading {
              cumulativePercent
            }
          }
          factors {
            id
            category
            name
            return {
              cumulativePercent
            }
          }
        }
      }
    }
  }
}`

export function createPerformanceCumulativeMultiDateQuery(modelId, positionSet, base, from, to, isIntradayMode) {
  const shouldUseIntradayQuery = isIntradayMode ? true : false
  const key = compact(
    [
      "cumulativePerformance",
      "multiDate",
      modelId,
      positionSet,
      from,
      to,
      shouldUseIntradayQuery,
      ...(shouldUseIntradayQuery ? [] : [base]),
    ])

  return {
    key,
    query: QUERY,
    variables: {
      modelId,
      positionSet,
      base: shouldUseIntradayQuery ? null : base,
      from,
      to,
    },
    select: (graphqlResult) => {
      const performance = get(graphqlResult, "data.model.simulation.performance", [])

      return {
        values: {
          formatter: percentageFormatter,
          // The code to map the dates data deliberately does not use lodash functions to improve the performance
          dates: performance.map(({ date, ...dateData }) => {
            const metrics = Object.entries(METRICS).reduce((acc, [metricId, metric]) => {
              acc[metricId] = get(dateData, metric.path)
              return acc
            }, {})

            const factors = dateData.attribution.factors.reduce((acc, { id, category, return: { cumulativePercent } }) => {
              acc[id] = cumulativePercent
              acc[category] = (acc[category] ?? 0) + cumulativePercent
              return acc
            }, {})

            return {
              date,
              ...metrics,
              ...factors,
            }
          }),
        },
      }
    },
  }
}
